import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { DocumentLoadInstrumentation } from '@opentelemetry/instrumentation-document-load';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { UserInteractionInstrumentation } from '@opentelemetry/instrumentation-user-interaction';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { BatchSpanProcessor, StackContextManager, WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { ATTR_SERVICE_NAME, ATTR_SERVICE_VERSION } from '@opentelemetry/semantic-conventions';

// Matches all Shiplex backend module paths: /voy/* (no /api suffix) and /<module>/api/*
const API_PATH_REGEX =
  /\/(voy|acc|att|bd|bun|comm|doc|exc|fre|frm|ism|map|md|oms|pda|pms|proc|pur|req|risk|rop|spo|tra|api)\//;

export function initTelemetry(): void {
  const endpoint = import.meta.env.VITE_OTEL_ENDPOINT;
  if (!endpoint) return;

  const version = (import.meta.env.VITE_APP_VERSION as string | undefined) ?? 'dev';

  const provider = new WebTracerProvider({
    resource: resourceFromAttributes({
      [ATTR_SERVICE_NAME]: 'Shiplex.Frontend',
      [ATTR_SERVICE_VERSION]: version
    }),
    spanProcessors: [new BatchSpanProcessor(new OTLPTraceExporter({ url: `${endpoint}/v1/traces` }))]
  });

  provider.register({ contextManager: new StackContextManager() });

  registerInstrumentations({
    instrumentations: [
      new DocumentLoadInstrumentation(),
      new XMLHttpRequestInstrumentation({ propagateTraceHeaderCorsUrls: [API_PATH_REGEX] }),
      new FetchInstrumentation({ propagateTraceHeaderCorsUrls: [API_PATH_REGEX] }),
      new UserInteractionInstrumentation()
    ]
  });
}
